// Correct place for CSS. Layout will just unmount and remount it and could cause issues.
// and the correct place is within gatsby-browser.js
require('./src/styles/index.scss');
require('./src/styles/required.scss');

const React = require('react');
const Layout = require('./src/components/Layout').default;

// Wraps every page in a Layout component
exports.wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>;
};

// Recommendation from the Gatsby Site
// https://www.gatsbyjs.com/docs/how-to/performance/add-offline-support-with-a-service-worker/
exports.onServiceWorkerUpdateReady = () => {
  console.log('Website Cache out of date. Reloading');
  window.location.reload();
};
